export default __webpack_public_path__ + "static/media/BANANA-EPS-BNB.4754a6db.svg";